/**
 * Plan limits and pricing constants
 */

// Free plan (Starter) limits
export const STARTER_DAILY_CANVAS_IMAGES = 8;
export const STARTER_DAILY_REFERENCE_TO_TEXTURE_IMAGES = 3;
export const STARTER_DAILY_MATERIALS = 2;

// Project Pack
export const PROJECT_PACK_GENERATIONS = 100;
